import React, { useState, useEffect } from 'react';
import { FaSpinner, FaTimes } from 'react-icons/fa';
import folderService from '../../services/folderService';
import './PdfViewerModal.css';

const PDF_EXTENSIONS = ['pdf'];

export const isPdfFile = (file) => {
    const ext = (file.original_filename || file.name || '').split('.').pop()?.toLowerCase();
    return PDF_EXTENSIONS.includes(ext);
};

const PdfViewerModal = ({ file, onClose }) => {
    const [viewUrl, setViewUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchViewUrl = async () => {
            if (!file?.id) {
                setError('No file provided');
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                setError(null);
                const res = await folderService.getFileViewUrl(file.id);
                if (res?.status && res?.data?.url) {
                    setViewUrl(res.data.url);
                } else {
                    setError('Failed to load PDF');
                }
            } catch (err) {
                setError(err.message || 'Failed to load PDF');
            } finally {
                setLoading(false);
            }
        };

        fetchViewUrl();
    }, [file]);

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!file) return null;

    return (
        <div className="pdf-viewer-overlay" onClick={handleBackdropClick}>
            <div className="pdf-viewer-modal">
                <div className="pdf-viewer-header">
                    <h3 className="pdf-viewer-title">{file.original_filename || file.name || 'PDF Document'}</h3>
                    <button
                        className="pdf-viewer-close"
                        onClick={onClose}
                        aria-label="Close PDF viewer"
                    >
                        <FaTimes />
                    </button>
                </div>
                <div className="pdf-viewer-content">
                    {loading && (
                        <div className="pdf-viewer-loading">
                            <FaSpinner className="pdf-viewer-spinner" />
                            <p>Loading PDF...</p>
                        </div>
                    )}
                    {error && !loading && (
                        <div className="pdf-viewer-error">
                            <p>{error}</p>
                            <button onClick={onClose}>Close</button>
                        </div>
                    )}
                    {!loading && !error && viewUrl && (
                        <iframe
                            src={viewUrl}
                            className="pdf-viewer-iframe"
                            title={file.original_filename || file.name || 'PDF Document'}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default PdfViewerModal;